export default __webpack_public_path__ + "static/media/news-page.9a54fc23.png";